// React
import PropTypes from "prop-types";

// @mui material components
import {
  Card,
  Fade,
  Grid,
  Icon,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Tooltip,
} from "@mui/material";

// Custom UI components
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import { useEffect, useState } from "react";
import { gql, useQuery } from "@apollo/client";
import SoftInput from "components/SoftInput";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90%",
  width: { xs: "90%", sm: "40%", xxl: "30%" },
  overflow: "auto",
};

export default function ModalMotivoRechazo({ open, handleClose, motivo }) {
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox>
            <SoftBox mb={2}>
              <SoftBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                p={3}
                pb={0}
              >
                <SoftBox display="flex"
                    flexDirection="column">
                  <SoftTypography variant="h6">Motivo del rechazo</SoftTypography>
                  <SoftTypography variant="caption">
                    Deberá volver a cargar el archivo y volver a solicitar su aprobación
                  </SoftTypography>
                </SoftBox>
                <SoftBox>
                  <Tooltip title="Cerrar" placement="top">
                    <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                      close
                    </Icon>
                  </Tooltip>
                </SoftBox>
              </SoftBox>
              <SoftBox p={3} py={1}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <SoftTypography variant="h7" fontWeight="bold">
                      {motivo}
                    </SoftTypography>
                  </Grid>
                </Grid>
              </SoftBox>
            </SoftBox>
            <SoftBox display="flex" justifyContent="end" alignItems="center" p={3} pt={0}>
              <SoftBox>
                <SoftButton color="primary" circular onClick={handleClose}>
                  <Icon sx={{ fontWeight: "light" }}>cancel</Icon>
                  &nbsp;Cerrar
                </SoftButton>
              </SoftBox>
            </SoftBox>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalMotivoRechazo.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  motivo: PropTypes.string,
};
